// frontend/src/utils/seo.ts
export const generatePageMeta = (
  title: string,
  description: string,
  clinicName: string = 'Elit-Med Clinic',
  siteName: string = 'Elit-Med Clinic',
  url?: string,
  image?: string
) => {
  const fullTitle = title.includes(clinicName) ? title : `${title} | ${clinicName}`;
  
  return {
    title: fullTitle,
    description,
    openGraph: {
      title: fullTitle,
      description,
      siteName,
      url,
      images: image ? [{ url: image, alt: title }] : [],
      type: 'website',
    },
    twitter: {
      card: 'summary_large_image',
      title: fullTitle,
      description,
      images: image ? [image] : [],
    },
  };
};

export const jsonLd = {
  organization: (clinicInfo: any) => ({
    '@context': 'https://schema.org',
    '@type': 'MedicalOrganization',
    name: clinicInfo.name,
    description: clinicInfo.description,
    url: clinicInfo.website,
    logo: clinicInfo.logo,
    image: clinicInfo.main_image,
    telephone: clinicInfo.phones,
    email: clinicInfo.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: clinicInfo.address,
      addressLocality: 'Yerevan',
      addressCountry: 'AM',
    },
    geo: clinicInfo.latitude && clinicInfo.longitude ? {
      '@type': 'GeoCoordinates',
      latitude: clinicInfo.latitude,
      longitude: clinicInfo.longitude,
    } : undefined,
    openingHours: 'Mo-Fr 09:00-18:00, Sa 09:00-14:00',
    sameAs: [
      clinicInfo.facebook_url,
      clinicInfo.instagram_url,
      clinicInfo.linkedin_url,
    ].filter(Boolean),
  }),
  
  doctor: (doctor: any, clinicName: string = 'Elit-Med') => ({
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': `#doctor-${doctor.slug}`,
    name: doctor.full_name,
    jobTitle: doctor.specialization,
    worksFor: {
      '@type': 'MedicalOrganization',
      name: clinicName,
    },
    image: doctor.photo,
    email: doctor.email,
    telephone: doctor.phone,
  }),

  service: (service: any, clinicName: string = 'Elit-Med') => ({
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: service.name,
    description: service.description,
    offers: service.price ? {
      '@type': 'Offer',
      price: service.price,
      priceCurrency: 'AMD',
    } : undefined,
    provider: {
      '@type': 'MedicalOrganization',
      name: clinicName,
    },
  }),
};
